import { Injectable } from '@angular/core';

const QUILL_CSS = [
  'https://cdn.quilljs.com/1.3.7/quill.snow.css',
  'https://cdn.quilljs.com/1.3.7/quill.bubble.css',
];
const GLIDER_CSS = ['https://cdnjs.cloudflare.com/ajax/libs/glider-js/1.7.9/glider.min.css'];

const loaded = new Set<string>();

/**
 * Injects optional/feature CSS on demand so they are not in initial load (reduces unused CSS).
 * Safe to call multiple times per key; each key is loaded at most once.
 */
@Injectable({ providedIn: 'root' })
export class OptionalStylesService {
  loadQuillOnce(): void {
    this.loadOnce('quill', QUILL_CSS);
  }

  loadGliderOnce(): void {
    this.loadOnce('glider', GLIDER_CSS);
  }

  private loadOnce(key: string, urls: string[]): void {
    if (typeof document === 'undefined') return;
    if (loaded.has(key)) return;
    const marker = urls[0];
    if (document.querySelector(`link[href="${marker}"]`)) {
      loaded.add(key);
      return;
    }
    loaded.add(key);
    const head = document.getElementsByTagName('head')[0];
    if (!head) return;
    for (const href of urls) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = href;
      head.appendChild(link);
    }
  }
}
